// Sheets（drive.file）アクセストークンの保持（Phase 2 / Slice 5b・B1方式）。
// D-0011 の非保持方針に準拠: メモリ(signal)のみに置き、localStorage には保存しない
// （ユーザー認証の sessionToken とは別物 = Google 側の一時アクセストークン）。
// 実際の取得（GIS + Picker）は Slice 5c で実装する。ここは B1 の送付経路を先に通すための保持箱。
import { signal } from "@preact/signals";
import { config } from "../config";

export const sheetsTokenSig = signal<string | undefined>(config.sheetsToken);

/** Slice 5c（Google OAuth + Picker）が取得後に呼ぶ想定。 */
export function setSheetsToken(token: string | undefined): void {
  sheetsTokenSig.value = token;
}

/** データ API に付与するヘッダ（未取得なら付けない）。 */
export function sheetsAuthHeaders(): Record<string, string> {
  const t = sheetsTokenSig.value;
  return t ? { "X-Sheets-Token": t } : {};
}
